<template>
    <div class="kanban">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="alert-wrapper">
            <alert-container :messages="msgs" />
        </div>
        <div class="filters-bar mb-3">
            <div class="filters-bar-form form-columns-fit">
                <div class="columns">
                    <div class="column is-5">
                        <vss-select
                            ref="funilSelect"
                            class="smaller no-clear"
                            label="descricao"
                            title="funil"
                            v-model="funilSelected"
                            :options="funilSelect"
                            :loading="funilLoading"
                            :height="40"
                            @search="carregarFunis"
                            @input="updateValueFunil"
                            searchable
                        />
                    </div>
                    <div class="column is-5">
                        <vss-select
                            title="etapa"
                            ref="etapaSelect"
                            class="smaller no-clear"
                            label="nome"
                            iconPosition="left"
                            v-model="etapaSelected"
                            :options="etapaSelect"
                            :height="40"
                            :loading="etapasLoading"
                            @search="carregarEtapas"
                            @input="updateValueEtapa"
                            :closeOnSelect="false"
                            no-clearfix
                            multiple
                            clearable
                            searchable
                            tooltipLabel="msg-atendimento-etapa-kanban"
                        >
                            <template #multiple-selected="{ selected }">
                                ({{
                                    selected && selected.length > 0
                                        ? selected.length
                                        : $t('todos')
                                }})
                            </template>
                        </vss-select>
                    </div>
                    <div class="column is-2">
                        <vss-select
                            ref="situacaoSelect"
                            :searchable="false"
                            :options="situacoes"
                            v-model="situacao"
                            @input="updateSituacao"
                            :height="40"
                            class="no-clear"
                            :mlLabels="true"
                            tooltipSize="is-small"
                            title="situacao"
                            :tooltipMultilined="true"
                        />
                    </div>
                </div>
            </div>
            <div class="filters-bar-actions">
                <div class="filter-options">
                    <b-button 
                        class="float-right"
                        @click="ChangeToList()" 
                        type="is-primary" 
                        icon-right="table" 
                        v-tippy 
                        :title="$t('formato-lista')"
                    />
                </div>
            </div>
        </div>
        <empty-table-message v-if="isEmpty" class="isEmpty" />
        <div v-else class="etapa-list">
            <div
                class="kanban-column"
                v-for="etapa in etapas"
                :key="etapa.id"
                @drop="handleDrop(etapa.id)"
                @dragover="allowDrop"
            >
                <div class="header-container">
                    <div
                        class="container"
                        :style="{ 'background-color': etapa && etapa.cor ? etapa.cor : '#D0CFCF' }"
                    >
                        <div class="icon-handle">
                            <i
                                :class="[
                                    'fas',
                                    etapa && etapa.icone ? etapa.icone : 'fa-arrows-alt',
                                ]"
                            ></i>
                        </div>
                        <div class="etapa">{{ etapa && etapa.nome ? etapa.nome : '---' }}</div>
                    </div>
                    <v-draggable :list="etapa.atendimentos" handle=".gp-handle">
                        <div
                            v-for="atendimento in etapa.atendimentos"
                            :key="atendimento.uuid"
                            class="atendimento-container"
                            @drag="handleDrag(atendimento)"
                        >
                            <div class="page-container">
                                <div class="titulo">
                                    <div class="gp-handle">
                                        <svg class="svg-icons column-drag-handle">
                                            <use
                                                :xlink:href="
                                                    require('@/assets/img/icons/drag.svg') +
                                                    '#layer'
                                                "
                                            ></use>
                                        </svg>
                                    </div>
                                    <div>
                                        <label
                                            v-text="
                                                atendimento &&
                                                atendimento.motivoAtendimento &&
                                                atendimento.motivoAtendimento.descricao
                                                    ? atendimento.motivoAtendimento.descricao
                                                    : '---'
                                            "
                                        />
                                        <div class="item">
                                            {{
                                                atendimento && atendimento.dataAtendimento
                                                    ? $moment(
                                                            atendimento.dataAtendimento
                                                        ).format('L')
                                                    : '---'
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="page-container"
                                :style="{ 'background-color': '#f7efff' }"
                            >
                                <!-- Label for 'codigo' -->
                                <div class="container-data">
                                    <div class="label">{{ $t('codigo') }}:</div>
                                    <div class="item">
                                        {{
                                            atendimento && atendimento.idAtendimentoErp
                                                ? atendimento.idAtendimentoErp
                                                : '---'
                                        }}
                                    </div>
                                </div>

                                <!-- Label for 'cliente' -->
                                <div class="container-data">
                                    <div class="label">{{ $t('cliente') }}:</div>
                                    <div class="item">
                                        {{
                                            atendimento &&
                                            atendimento.cliente &&
                                            atendimento.cliente.nome
                                                ? atendimento.cliente.nome
                                                : '---'
                                        }}
                                    </div>
                                </div>

                                <!-- Label for 'colaborador' -->
                                <div class="container-data">
                                    <div class="label">{{ $t('colaborador') }}:</div>
                                    <div class="item">
                                        {{
                                            atendimento &&
                                            atendimento.usuario &&
                                            atendimento.usuario.nome
                                                ? atendimento.usuario.nome
                                                : '---'
                                        }}
                                    </div>
                                </div>

                                <!-- Label for 'fotos' -->
                                <div class="container-data">
                                    <div class="label">{{ $t('fotos') }}:</div>
                                    <div class="item">
                                        {{
                                            atendimento &&
                                            atendimento.foto &&
                                            atendimento.foto.quantidade
                                                ? atendimento.foto.quantidade
                                                : 0
                                        }}
                                    </div>
                                </div>

                                <!-- Label for 'formularios' -->
                                <!-- <div class="container-data">
                                <div class="label"> {{ $t('formularios') }}: </div>
                                <div class="item"> 
                                    {{ 
                                        atendimento && atendimento.formularios ? 
                                        atendimento.formularios : 0
                                    }}
                                </div>
                            </div> -->
                            </div>
                            <div
                                class="page-container clickable"
                                @click="showModalEdit(atendimento.uuid)"
                            >
                                <div
                                    class="icon-handle-atendimento"
                                    v-if="atendimento.situacao == 0"
                                >
                                    <b-icon icon="pencil" type="is-primary" class="mr-2" />
                                    <small>
                                        {{ $t('em-preenchimento') }} -
                                        {{ $t('editar') }}
                                    </small>
                                </div>
                                <div class="icon-handle-atendimento" v-else>
                                    <b-icon
                                        icon="check-circle"
                                        type="is-success"
                                        class="mr-2"
                                    />
                                    <small>
                                        {{ $t('finalizado') }} -
                                        {{ $t('visualizar') }}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </v-draggable>
                </div>
            </div>
        </div>
        <lateral-content v-model="showModalAtendimentoManage" v-if="uuid != ''">
            <AtendimentoManage
                class="manage-content"
                v-if="showModalAtendimentoManage"
                cameFrom="AtendimentoKanban"
                :uuidFrom="uuid"
                :isUpdate="true"
                @saved="carregarAtendimentos()"
                @voltar="showModalAtendimentoManage = false"
            />
        </lateral-content>
    </div>
</template>

<script>
import FunilService from '@/services/FunilService';
import EtapaService from '@/services/EtapaService';
import AtendimentoService from '@/services/AtendimentoService';
const AtendimentoManage = () => import('@/components/vendas/atendimento/AtendimentoManage.vue');

/********* utils *********/
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        ContainerLoader,
        AtendimentoManage,
    },
    data() {
        return {
            funilService: new FunilService(this.$http, this.$router),
            etapaService: new EtapaService(this.$http, this.$router),
            service: new AtendimentoService(this.$http, this.$router),

            isLoading: false,
            msgs: [],
            permissao: {},
            isEmpty: true,

            funilSelect: [],
            funilSelected: null,
            funilLoading: false,

            etapaSelect: [],
            etapaSelected: [],
            etapasLoading: false,

            etapa: null,
            etapas: [],
            length: 0,

            atendimentoList: [],
            atendimento: null,

            situacoes: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacao: { label: 'ativo', id: 1 },

            showModalAtendimentoManage: false,
            uuid: '',
            draggedAtendimento: null,
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-atendimento');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'atendimentos' },
            });
        } else {
            // this.carregarFunis();
        }
    },
    methods: {
        ChangeToList() {
            this.$emit('changeTab', 0);
        },
        carregarFunis(search = '') {
            this.funilLoading = true;

            this.funilService
                .findAllCombo(0, search)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `[ATENDIMENTO-LIST] Erro status ${r.status} ao carregar funil.`
                        );
                        console.error(`[ATENDIMENTO-LIST] Mensagem: ${r.message}`);
                    } else {
                        this.funilSelect = r.content;
                    }
                })
                .catch((e) => {
                    console.error('[ATENDIMENTO-LIST] Erro ao carregar funil.', e);
                })
                .finally((_) => {
                    if (this.funilSelect.length > 0 && this.funilSelected == null) {
                        this.funilSelected = this.funilSelect[0];
                    }
                    this.carregarEtapas();
                    this.funilLoading = false;
                });
        },
        carregarEtapas(search = '') {
            if (this.funilSelected && this.funilSelected.idFunil > 0) {
                const idFunil = this.funilSelected.idFunil;

                this.etapasLoading = true;

                this.etapaService
                    .findAllCombo(idFunil, this.situacao.id, search)
                    .then((body) => {
                        this.etapaSelect = Object.assign(body.content);
                    })
                    .catch((e) => {
                        this.etapasLoading = false;
                        console.error(
                            `[ATENDIMENTO-LIST] Erro ao realizar pesquisa da etapa. Termo: [${search}]`,
                            e
                        );
                    })
                    .finally((_) => {
                        this.carregarAtendimentos();
                        this.etapasLoading = false;
                    });
            }
        },
        carregarAtendimentos() {
            this.isLoading = true;
            this.service
                .findAllCombo('')
                .then(this.mapItems)
                .then((value) => {
                    this.atendimentoList = value;
                })
                .catch((e) => {
                    console.error('Erro ao carregar Atendimentos.', e);
                    this.$root.showMessage('error', 'msg-erro-dados-geral');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.updateDados();
                });
        },
        updateDados() {
            if (this.etapaSelected.length > 0) {
                this.carregarDados(this.etapaSelected);
            } else if (this.etapaSelect.length > 0) {
                this.carregarDados(this.etapaSelect);
            } else {
                this.isEmpty = true;
            }
        },
        mapItems({ content }) {
            return content.map((a) => {
                return {
                    uuid: a.uuid,
                    idAtendimento: a.idAtendimento,
                    dataAtendimento: a.dataAtendimento,
                    motivoAtendimento: { descricao: a.motivoAtendimento.descricao },
                    idAtendimentoErp: a.idAtendimentoErp,
                    cliente: { nome: a.cliente.nome },
                    usuario: { nome: a.usuario.nome },
                    foto: { quantidade: a.foto.quantidade },
                    // formularios: 0,
                    etapa: { idEtapa: a.etapa.idEtapa },
                    situacao: a.situacao,
                };
            });
        },
        carregarDados(etapas) {
            this.isLoading = true;

            this.service
                .findAllByIdFunilAndIdEtapa(etapas)
                .then(this.mapIcon)
                .then((content) => {
                    this.etapas = this.mapEtapas(content);

                    if (this.length > 0) {
                        this.isEmpty = false;
                    } else {
                        this.isEmpty = true;
                    }
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        mapIcon(body) {
            if (body) {
                if (body.content) {
                    this.etapas = null;
                    this.length = body.totalElements;

                    return body.content.map((obj) => {
                        const modifiedObj = { ...obj };

                        // Remove 'fas' substring from the 'icon' property
                        if (modifiedObj.icone.startsWith('FAS ')) {
                            modifiedObj.icone = modifiedObj.icone.slice(4);
                            modifiedObj.icone = modifiedObj.icone.toLowerCase();
                        }

                        this.$set(modifiedObj, 'icone', modifiedObj.icone);

                        modifiedObj.cor = this.lightenColor(modifiedObj.cor);

                        this.$set(modifiedObj, 'cor', modifiedObj.cor);

                        return modifiedObj;
                    });
                }
            }
        },
        lightenColor(hexColor) {
            const rgbColor = this.hexToRgb(hexColor);
            const hslColor = this.rgbToHsl(rgbColor.r, rgbColor.g, rgbColor.b);

            if (hslColor.l < 50) {
                const checkLightness = hslColor.l + 20;
                if (checkLightness >= 0 && checkLightness <= 100) {
                    hslColor.l = hslColor.l + 20; // Make the color 20% lighter
                }
            } else {
                const checkDarkness = hslColor.l - 20;
                if (checkDarkness >= 0 && checkDarkness <= 100) {
                    hslColor.l = hslColor.l - 20; // Make the color 20% darker
                }
            }

            return `hsl(${hslColor.h}, ${hslColor.s}%, ${hslColor.l}%)`;
        },
        // Create a new array where each 'etapa' contains its associated 'atendimentos'
        mapEtapas(content) {
            const etapasWithAtendimentos = content.map((etapa) => {
                const etapaAtendimentos = this.atendimentoList.filter(
                    (atendimento) => atendimento.etapa.idEtapa === etapa.id
                );

                return { ...etapa, atendimentos: etapaAtendimentos };
            });
            return etapasWithAtendimentos;
        },
        updateValueFunil(valor) {
            this.funilSelected = valor;

            this.etapaSelected = [];
            this.etapaSelect = [];

            this.carregarEtapas();
        },
        updateValueEtapa(valor) {
            this.etapaSelected = valor;

            this.etapa = null;
            this.etapas = [];

            this.updateDados();
        },
        updateSituacao(situacao) {
            this.situacao = situacao;

            this.etapaSelected = [];
            this.etapaSelect = [];

            this.etapa = null;
            this.etapas = [];

            this.carregarEtapas();
        },
        showModalEdit(uuid) {
            this.uuid = uuid;
            this.showModalAtendimentoManage = true;
        },
        handleDrag(atendimento) {
            this.draggedAtendimento = atendimento;
        },
        allowDrop(event) {
            event.preventDefault();
        },
        handleDrop(targetEtapaId) {
            if (
                this.draggedAtendimento &&
                targetEtapaId &&
                this.draggedAtendimento.etapa.idEtapa !== targetEtapaId.id
            ) {
                const targetEtapa = this.etapas.find((etapa) => etapa.id === targetEtapaId);
                const targetAtendimento = this.atendimentoList.find(
                    (atendimento) => atendimento.uuid === this.draggedAtendimento.uuid
                );

                if (targetEtapa && targetAtendimento) {
                    targetAtendimento.etapa.idEtapa = targetEtapa.id;

                    this.updateEtapaAtendimento(targetAtendimento);
                }
                this.draggedAtendimento = null;
            }
        },
        updateEtapaAtendimento(atendimento) {
            this.isLoading = true;

            this.service
                .updateEtapaAtendimento(atendimento)
                .then((body) => {
                    if (body.status == 200) {
                        this.carregarAtendimentos();
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar atendimento para a etapa.', e);

                    if (this.$te(e.body.message)) {
                        this.$root.showMessage('alert', e.body.message, true);
                    } else {
                        this.$root.showMessage('error', 'msg-problema-realizar-acao');
                    }
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.kanban {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}
.etapa-list {
    display: flex;
    margin-bottom: 20px;
}
.kanban-column {
    min-width: 250px;
    padding-right: 10px;
}
.atendimento-container {
    margin: 8px;
}
.header-container {
    background-color: #f6f6f6;
    overflow-y: auto;
    padding-bottom: 15px;
    border: 1px solid $table-border;
    border-radius: 5px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
    height: 100%;
    margin: 5px;
}
.container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 0;
}
.icon-handle {
    color: #fff;
    margin-right: 10px;

    svg {
        width: 40px;
        height: 32px;
    }
}
.etapa {
    font-style: normal;
    font-weight: 1000;
    line-height: normal;
    font-size: 17px;
    color: #fff;
}
.titulo {
    display: flex;
    align-items: center;
    flex: 1;
}
.gp-handle {
    display: inline-flex;
    margin-right: 10px;

    svg {
        transform: rotate(90deg);
    }
}
.icone-check {
    margin: 5px;
}
.icon-handle-atendimento {
    padding: 5px;
}
label {
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    font-size: 12;
    color: $primary-color;
}
.label {
    color: $sovis-black;
    padding: 0 10px 0 5px;
    font-size: 12px;
    font-weight: 1000;
}
.item {
    font-size: 12px;
    padding-bottom: 5px;
}
.data {
    background-color: hsl(270, 100%, 96.94%);
    padding: 10px;
}
.container-data {
    display: flex;
    align-items: center;
}
.page-container {
    padding: 0px;
    border-radius: 3px;
}
.filters-bar {
    display: flex;
    padding: 20px 0 10px 0;
    .filters-bar-form {
        flex-grow: 1;
    }
    .filters-bar-actions {
        display: flex;
        padding: 15px;
        align-items: stretch;
    }


    @media screen and (min-width: 851px) {
        .filters-bar-actions {
            align-self: flex-end;
        }
    }
    @media screen and (max-width: 850px) {
        flex-direction: column;
        .filters-bar-actions {
            align-self: center;
            margin-top: 10px;
        }
    }
}
.mt-2-custom {
    margin-top: 35px;
}
.manage-content {
    padding: 20px;
}
@media screen and (max-width: 930px) {
    .mt-2-custom {
        margin-top: 0;
        .float-right {
            float: left;
            margin: 15px 15px 0 15px;
        }
    }
    .column {
        width: 100%;
    }
    .etapa {
        font-weight: 800;
        font-size: 15px;
    }
}
</style>
